import httpRequest from '@/utils/request';

const settlementUnitUrl = `/SettlementConfiguration`;

const createSettlementUnitUrl = (settlementUnitId: string): string => {
  return `${settlementUnitUrl}/${settlementUnitId}`;
};

export const getSettlementUnits = (
  params: ISettlementUnit.IRequest.IGetSettlementUnits = {},
): Promise<ISettlementUnit.IResponse.IData> => {
  return httpRequest.get(settlementUnitUrl, {
    params,
  });
};

export const updateSettlementUnit = (
  params: ISettlementUnit.IRequest.IUpdateSettlementUnit,
): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(createSettlementUnitUrl(params.id), params.data);
};
export const deleteSettlementUnit = (
  SettlementUnitId: string,
): Promise<IResponseData.IBaseData> => {
  return httpRequest.delete(createSettlementUnitUrl(SettlementUnitId));
};
